import IGGrabedPostList from '@/data/igGrabedPost/view/list.vue'

const list = {
  path: '/ig-post',
  name: 'igpost-list',
  component: IGGrabedPostList
}

export default [list]
